import { PureComponent } from 'react'
import styled from 'glamorous'
import { $ } from 'utils'


const Container = styled.div({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  paddingLeft: 80,
  paddingRight: 80,
})

const Nothing = styled.div({
  fontSize: 20,
})

const Choose = styled.div({
  fontSize: 16,
  color: 'var(--lightGrey)'
})


export class EmptyDetails extends PureComponent {

  render = () =>
    $(Container,
      $(Nothing, 'Nothing selected'),
      $(Choose, 'Please choose something or create a new one')
    )
}

export default EmptyDetails



// WEBPACK FOOTER //
// ./src/components/EmptyDetails.js